import React, { useMemo } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const PALETTE = ["#22d3ee", "#3b82f6", "#a78bfa", "#f472b6", "#f59e0b", "#10b981", "#ef4444",
  "#14b8a6", "#eab308", "#8b5cf6", "#06b6d4", "#84cc16"];

const colorOf = (d, i) => (d.name.startsWith("Autres") ? "#64748b" : PALETTE[i % PALETTE.length]);

export const PortfolioDonut = ({ rows, total, cap }) => {
  const data = useMemo(() => {
    const top = rows.slice(0, 12).map((r) => ({ name: r.ticker, value: r.total_value, pct: r.weight_pct }));
    const rest = rows.slice(12);
    if (rest.length) {
      const v = rest.reduce((a, r) => a + r.total_value, 0);
      top.push({ name: `Autres (${rest.length})`, value: v, pct: rest.reduce((a, r) => a + r.weight_pct, 0) });
    }
    return top;
  }, [rows]);

  return (
    <div className="bg-slate-800/30 border border-slate-700 rounded-lg p-4" data-testid="pe-donut">
      <div className="font-semibold text-slate-100 mb-2">Répartition du portefeuille</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
        <div className="relative h-72">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={data} dataKey="value" nameKey="name" innerRadius="58%" outerRadius="92%" paddingAngle={1} stroke="#0f172a">
                {data.map((d, i) => <Cell key={d.name} fill={colorOf(d, i)} />)}
              </Pie>
              <Tooltip
                contentStyle={{ background: "#0f172a", border: "1px solid #22d3ee", borderRadius: 8, fontSize: 13, padding: "6px 10px" }}
                itemStyle={{ color: "#f1f5f9", fontWeight: 600 }}
                labelStyle={{ color: "#f1f5f9" }}
                formatter={(v, n, p) => [`€${Math.round(v).toLocaleString("fr-FR")} · ${p.payload.pct.toFixed(1)}%`, n]}
              />
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
            <div className="text-[11px] text-slate-400">Total</div>
            <div className="text-lg font-bold text-cyan-400" data-testid="pe-donut-total">€{Math.round(total).toLocaleString("fr-FR")}</div>
          </div>
        </div>
        <div className="space-y-1.5" data-testid="pe-donut-legend">
          {data.map((d, i) => (
            <div key={d.name} className="flex items-center gap-2 text-xs">
              <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ background: colorOf(d, i) }} />
              <span className="w-24 text-slate-200 font-semibold truncate">{d.name}</span>
              <div className="flex-1 bg-slate-700/60 rounded-full h-1.5 overflow-hidden">
                <div className="h-full" style={{ width: `${Math.min(100, (d.pct / 25) * 100)}%`, background: colorOf(d, i) }} />
              </div>
              <span className={`w-14 text-right font-mono ${d.pct > cap ? "text-red-400 font-bold" : d.pct > 10 ? "text-amber-400" : "text-slate-300"}`}>
                {d.pct.toFixed(1)}%
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
